/**
 * Created by Mark on 17/04/2017.
 */

import React from 'react';
import { Button , Modal , Row , Col , Alert} from 'react-bootstrap';
import ContentNavigation from './content-header.js';
import Checkout from '../content-checkout.js';


export default class ContentJustHeaderLayout extends React.Component {

    constructor(props){
        super();
        this.props = props;
    }


    render(){

        return <div>
                    <Row>
                        <Col md={6}>
                            <ContentNavigation />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            {this.props.children}
                        </Col>
                    </Row>
               </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/layouts/content-just-header-page.js